import React, { useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import classNames from 'classnames';

const CATEGORIES = [
  {
    key: 'necessary',
    title: "Обов'язкові cookie",
    disabled: true,
    description:
      'Ці файли cookie необхідні для функціонування веб-сайту і не можуть бути відключені в наших системах. Зазвичай вони встановлюються тільки у відповідь на ваші дії, що призводять до запиту на послуги, такі як установка налаштувань конфіденційності, вхід в систему або заповнення форм. Ви можете налаштувати свій браузер так, щоб він блокував або попереджав вас про ці файли cookie, але деякі частини сайту можуть не працювати.'
  },
  {
    key: 'operational',
    title: 'Експлуатаційні cookie',
    description:
      "Ці файли cookie необхідні для роботи веб-сайту або його функцій, які ви можете використовувати для зручності. Наприклад: щоб пам'ятати, хто ви, ваші уподобання та налаштування, щоб вам не потрібно було вводити їх щоразу, коли ви змінюєте сторінку; щоб правильно відображати вміст на пристрої; запобігати шахрайству (наприклад, щоб переконатися, що одна і та ж особа не виконує одне і те ж опитування двічі). Оскільки ці функції необхідні для нормальної роботи сайту, тому неможливо відмовитися від цього виду cookies. Тим не менш, якщо ви хочете, ви можете налаштувати свій браузер, щоб відхилити всі файли cookie, в цьому випадку сайт може не відображатися належним чином, і вибрані вами функції можуть бути недоступні."
  },
  {
    key: 'performance',
    title: 'Файли cookie для продуктивності',
    description:
      'Вони дозволяють зрозуміти, як люди в цілому (а не будь-яка фізична особа) використовують сайт, і наскільки добре сайт працює. У свою чергу, це дозволяє нам поліпшити спосіб роботи сайту. Для цього ми використовуємо ці технології розташовані, потім агреговані, і тільки тоді (коли з даних не можна виокремити конкретну особу) ми аналізуємо його. На ваш розсуд Ви можете вибрати або відмовитися від використання цих файлів cookie.'
  },
  {
    key: 'tracking',
    title: 'Відстежуючі cookie',
    description:
      'Ці файли cookie відстежують ваше використання нашого сайту та інших сайтів. Чому і як ми їх використовуємо. Перш за все ми хочемо, щоб ви насолоджувалися вашою взаємодією з нами: ми адаптуємо наші пропозиції відповідно до вашого досвіду з нами та ваших інтересів, наприклад, щоб:\n' +
      'дати вам персоналізований досвід взаємодії з нами, наприклад, ваші дзвінки в колл-центри, ваші візити в наші магазини та відвідування наших інтернет-сайтів чи мобільних додатків; \n' +
      'персоналізувати наші оголошення, контент і комунікації; \n' +
      'зафіксувати ваш регулярний інтерес до наших брендів. \n\n' +
      "Ці файли cookie відіграють важливу роль у цьому. Як це працює? Ми слідкуємо за тим як ви з нами взаємодієте. Наприклад, ми відзначаємо, що ви купуєте у нас, і як обробляються ваші дзвінки в центрі обробки викликів клієнтів. Ми використовуємо пікселі відстеження (де ви це дозволяєте), щоб відзначити, які електронні комунікації від нас ви відкриваєте, і які посилання в них ви натискаєте. Крім того, якщо ви погоджуєтеся на це на цьому веб-сайті або на іншому нашому веб-сайті, ми використовуємо файли cookie (та подібні технології) в електронному вигляді, щоб слідкувати за тим, як ви використовуєте наші та певні сторонні веб-сайти та мобільні додатки. На останок, ми об'єднуємо наші знання з усіх цих каналів (наскільки ми можемо; наприклад, якщо ви не перебуваєте в одній з наших баз даних, ми менш ймовірно зможемо це зробити), щоб створити картину ваших уподобань і того, що вас цікавить. Ви можете вибрати або відмовитися від нашого використання цих файлів cookie на ваш розсуд."
  },
  {
    key: 'target',
    title: 'Цільові cookies',
    description:
      'Ці файли cookie встановлюються через наш сайт нашими рекламними партнерами. Вони можуть використовуватися цими компаніями для створення профілю ваших інтересів і показу вам релевантних оголошень на інших сайтах. Вони працюють, унікально ідентифікуючи ваш браузер і пристрій. Якщо ви не дозволите використання цих файлів cookie, ви не побачите нашу цільову комунікацію на різних сайтах.'
  }
];

const CookieToggle = ({ checked, disabled, onChange }) => (
  <button
    type="button"
    className={classNames(styles.toggle, {
      [styles.toggleOff]: !checked && !disabled,
      [styles.toggleDisabled]: disabled
    })}
    onClick={disabled ? undefined : onChange}
    disabled={disabled}
    aria-label="toggle"
  >
    <span className={styles.thumb} />
  </button>
);

const CookieManagementComponent = ({ setScreenNumber }) => {
  const [moreInfoOpen, setIsMoreInfoOpen] = useState(false);
  const [openMap, setOpenMap] = useState({});
  const [checkedMap, setCheckedMap] = useState({
    operational: true,
    performance: false,
    tracking: true,
    target: true
  });

  const toggleOpen = (key) =>
    setOpenMap((prev) => ({ ...prev, [key]: !prev[key] }));

  const toggleChecked = (key) =>
    setCheckedMap((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleAcceptAllCookies = () => {
    setCheckedMap({
      operational: true,
      performance: true,
      tracking: true,
      target: true
    });
    setScreenNumber(1);
  };

  return (
    <div className={styles.container}>
      <img
        src={getImageFromS3('/images/mgm/bg.png')}
        alt="background"
        className={styles.backgroundImage}
      />
      <div className={styles.content}>
        <div className={styles.card}>
          <p className={styles.headTitle}>Налаштування файлів cookie</p>
          <p className={styles.text}>
            {"Що таке cookies? Cookies - короткі комп'ютерні програми, написані в зрозумілому для людини тексті. Вони розміщуються на вашому пристрої під час відвідування сайту і використовуються для ідентифікації вашого пристрою для цілей описаних тут. \n\n" +
              'Файли cookie, встановлені власником сайту, називаються «cookie першої сторони». Файли cookie, встановлені іншими особами називають «сторонніми файлами cookie». Сторонні файли cookie дозволяють третій стороні надавати нам послуги, щоб ми могли забезпечувати функціональність сайту (наприклад, аналітику, рекламу та відео). Сторони, які встановлюють ці файли cookie можуть розпізнавати ваш пристрій як при відвідуванні нашого сайту, так і при відвідуванні деяких інших сайтів.'}
            {!moreInfoOpen && (
              <p
                className={styles.moreInfoButton}
                onClick={() => setIsMoreInfoOpen(true)}
              >
                Більше інформації
              </p>
            )}
            {moreInfoOpen
              ? '\n\nЦі файли cookie поділяються на три категорії. Ті, що у першій категорії - необхідні. Ті, що в інших двох категоріях є необов\'язковими: ви можете вирішувати, чи хочете ви отримати їх від нас, і ви можете використовувати цей інструмент, щоб встановлювати свої уподобання. Ви можете змінити свою думку в будь-який час, перейшовши за посиланням "Налаштування файлів cookie" з будь-якої сторінки сайту.'
              : ''}
          </p>
          <p className={styles.headTitle}>Керування налаштуваннями cookie</p>
          <div className={styles.tableContainer}>
            {CATEGORIES.map((cat) => (
              <React.Fragment key={cat.key}>
                <div
                  className={styles.tableHead}
                  style={openMap[cat.key] ? { border: 'none' } : null}
                >
                  <div
                    className={styles.title}
                    onClick={() => toggleOpen(cat.key)}
                  >
                    <span className={styles.icon}>
                      {openMap[cat.key] ? '−' : '+'}
                    </span>
                    {cat.title}
                  </div>
                  <CookieToggle
                    checked={cat.disabled ? true : checkedMap[cat.key]}
                    disabled={cat.disabled}
                    onChange={() => toggleChecked(cat.key)}
                  />
                </div>
                {openMap[cat.key] && (
                  <p className={styles.tableText}>{cat.description}</p>
                )}
              </React.Fragment>
            ))}
          </div>
          <button
            className={styles.acceptButton}
            onClick={handleAcceptAllCookies}
          >
            Погоджуюся з усім
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieManagementComponent;
